function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#F5F5F5"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.8789 26.6755C22.2744 26.6755 22.5995 26.3402 22.6089 25.9428L22.8212 16.9319C22.8306 16.5285 22.5115 16.189 22.1081 16.1796C21.6984 16.1735 21.3701 16.4868 21.3607 16.89L21.1485 25.9096C21.1389 26.3128 21.458 26.6755 21.8614 26.6755H21.8789ZM18.4369 26.6755H18.4544C18.8578 26.6755 19.1769 26.2876 19.1675 25.8842L18.9553 16.8614C18.9457 16.458 18.6149 16.1285 18.2078 16.1374C17.8046 16.1468 17.4852 16.4759 17.4948 16.8793L17.7071 25.9213C17.7165 26.3187 18.0414 26.6755 18.4369 26.6755ZM18.0869 13.1103H22.2608V12.0668H18.0869V13.1103ZM29.1478 13.9451C29.1478 14.4061 28.774 14.7799 28.313 14.7799H12.0347C11.5737 14.7799 11.2 14.4061 11.2 13.9451C11.2 13.4841 11.5737 13.1103 12.0347 13.1103H16.6261V11.232C16.6261 10.8286 16.8951 10.606 17.2985 10.606H23.0491C23.4525 10.606 23.7217 10.8286 23.7217 11.232V13.1103H28.313C28.774 13.1103 29.1478 13.4841 29.1478 13.9451ZM26.935 16.7391L26.2978 28.8065C26.2745 29.2498 25.9082 29.5973 25.4643 29.5973H14.8834C14.4396 29.5973 14.0733 29.2498 14.0499 28.8065L13.413 16.7391C13.3886 16.2787 13.7421 15.8857 14.2025 15.8615C14.6651 15.8392 15.056 16.1909 15.0802 16.651L15.6755 27.9277H24.6723L25.2675 16.651C25.2919 16.1906 25.6876 15.8407 26.1453 15.8615C26.6057 15.8857 26.9592 16.2787 26.935 16.7391Z",
  fill: "#1F2F53"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 17.9478,
  height: 19.2,
  fill: "white",
  transform: "translate(11.2 10.3999)"
})));

var SvgIconDelete = function SvgIconDelete(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconDelete, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_delete.a6303f09.svg";
export { ForwardRef as ReactComponent };